import { Link as RouterLink } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang, copy } from "@/i18n";

const scrollTo = (id) => (e) => {
  e.preventDefault();
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { duration: 2.6 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export default function Nav({ showLogo = true }) {
  const { lang } = useLang();
  const c = copy[lang].nav;
  const { scrollY } = useScroll();
  const navOpacity = useTransform(scrollY, [10, 130], [0, 1]);

  const links = [
    { id: "torque", label: c.torque, testid: "nav-link-torque" },
    { id: "archivio", label: c.archive, testid: "nav-link-archive" },
    { to: "/perspectives", label: "Perspectives", testid: "nav-link-perspectives" },
  ];

  return (
    <motion.header
      data-testid="main-nav"
      className="fixed top-0 left-0 right-0 z-40 border-b backdrop-blur-md"
      style={{
        opacity: navOpacity,
        borderColor: "var(--line-soft)",
        background: "color-mix(in srgb, var(--paper) 78%, transparent)",
      }}
    >
      <div className="flex items-center justify-between px-6 md:px-14 py-5">
        <a
          data-testid="nav-logo"
          href="#inizio"
          onClick={scrollTo("inizio")}
          className="block"
        >
          <img
            src="/fmf-logo.png"
            alt="FMF"
            className={`h-[54px] w-auto transition-opacity duration-1000 ${
              showLogo ? "opacity-100" : "opacity-0"
            }`}
          />
        </a>
        <nav className="hidden md:flex flex-1 items-center justify-center gap-10">
          {links.map((l) =>
            l.to ? (
              <RouterLink
                key={l.to}
                data-testid={l.testid}
                to={l.to}
                className="font-mono-fmf text-[15px] uppercase tracking-[0.35em] text-[var(--graphite)] hover:text-[var(--ink)] transition-colors duration-700"
              >
                {l.label}
              </RouterLink>
            ) : (
              <a
                key={l.id}
                data-testid={l.testid}
                href={`/#${l.id}`}
                onClick={(e) => {
                  if (window.location.pathname === "/") {
                    scrollTo(l.id)(e);
                  }
                }}
                className="font-mono-fmf text-[15px] uppercase tracking-[0.35em] text-[var(--graphite)] hover:text-[var(--ink)] transition-colors duration-700"
              >
                {l.label}
              </a>
            )
          )}
        </nav>
        <span className="w-[93px] hidden md:block" aria-hidden="true" />
      </div>
    </motion.header>
  );
}
